export default __webpack_public_path__ + "static/media/lumisight.7165a953.png";